/**
 *   This is a service for a specific store module which uses the api.ts Axios instance as a base.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */

import Api from '@/services/api';
import { MessageDestination } from '@/models/Sms.model';

export default {

  create(params: {
    destinations: MessageDestination[],
    message: string,
  }) {
    return Api(true).post('/message/create', params);
  },

}